import React from "react";
import { useTranslation } from "react-i18next";

import { convertLanguageToField } from "../../../utils/functions";

import styles from "./rouletteChallenge.module.css";

import { StyledText } from "../../desafiosPicantes/game";
import HotLevelIcon from "../../desafiosPicantes/hotLevelIcon";
import Timer from "../../timer";
import Feedback from "../feedback";

export default function SexRouletteChallenge({
  player1,
  player2,
  containerRef,
  challenge,
  onNext,
}) {
  const { t, i18n } = useTranslation();

  const getChallenge = () => {
    const field = convertLanguageToField(i18n.language, "desafio");
    return challenge[field] || "";
  };

  return (
    <div ref={containerRef} className={styles.container}>
      <div className="text-center mb-8">
        <span className={styles.span}>{t("vezDe")}</span>
        <h2 className="text-2xl leading-4 font-extrabold">{player1.name}</h2>
      </div>
      <div className={styles.hotLevel}>
        <div className="flex justify-center items-center w-56 ms-5">
          {[1, 2, 3, 4, 5].map((i) => {
            return (
              <HotLevelIcon
                activeColor="white"
                inactiveColor="#454A58"
                key={i}
                className="pe-4"
                active={challenge?.hot_level >= i}
              />
            );
          })}
        </div>
      </div>
      <div className="flex flex-1 flex-col mt-3 mb-3 scroll">
        <StyledText
          className={`${styles.challenge}`}
          phrase={getChallenge()}
          userName={player2.name}
          playerOneName={player1.name}
        />
      </div>
      <div className="mb-5">
        <Feedback
          likes={challenge.like}
          deslikes={challenge.dislike}
          id={challenge.id_cena}
        />
      </div>
      {challenge?.duracao ? (
        <div className="flex justify-center">
          <Timer timer={challenge.duracao} className="text-center mt-5" />
        </div>
      ) : null}
      <div>
        <button
          type="button"
          onClick={onNext}
          className="btn btn-brand w-full mb-5 mt-5"
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
}
